module.exports = __webpack_public_path__ + "media/images/icons/contact-af97be72b45845706531864a657572d2.svg";